module.exports = __webpack_public_path__ + "static/simply the best-300bdc5467d5225e9cef7b9b1593d74e.svg";